import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const BookMockup = () => {
  return (
    <div className="relative w-[260px] h-[360px] sm:w-[280px] sm:h-[400px] perspective-[2500px] group mx-auto">
      {/* Aura de Prestígio */}
      <motion.div 
        animate={{ opacity: [0.2, 0.4, 0.2], scale: [1, 1.1, 1] }}
        transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        className="absolute inset-0 bg-amber-200/20 blur-[80px] rounded-full transform -translate-y-4"
      />
      
      {/* Sombra */}
      <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 w-[80%] h-[10px] bg-stone-950/30 blur-[12px] rounded-full" />

      {/* Livro/Passaporte */}
      <motion.div 
        animate={{ 
          y: [-8, 8, -8],
          rotateY: [-12, -6, -12],
          rotateX: [5, 2, 5]
        }}
        transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
        className="relative w-full h-full transform-gpu"
        style={{ transformStyle: 'preserve-3d' }}
      >
        {/* CAPA - Minimalista e Legível */}
        <div 
          className="absolute inset-0 rounded-r-xl rounded-l-sm bg-[#2a1f19] shadow-[15px_15px_40px_rgba(0,0,0,0.4)] overflow-hidden border border-[#4a3b32]"
          style={{ transform: 'translateZ(20px)' }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-[#3e2723] to-[#1a120f]" />
          
          {/* Detalhe Dourado */}
          <div className="absolute inset-4 border border-[#d4af37]/15 rounded-sm pointer-events-none" />
          
          <div className="absolute inset-0 p-8 flex flex-col items-center justify-between text-center relative z-10">
            <div className="mt-4">
              <SafeIcon name="Heart" className="w-8 h-8 text-[#d4af37] mx-auto mb-4" />
              <div className="h-px w-8 bg-[#d4af37]/30 mx-auto" />
            </div>

            <div className="my-auto flex flex-col items-center gap-4">
              <img 
                src="https://i.imgur.com/LJ9Fcbk.png" 
                alt="UniPET" 
                className="w-32 h-auto brightness-0 invert opacity-90" 
                loading="lazy"
              />
              <p className="text-[10px] font-bold uppercase tracking-[0.5em] text-[#cba365]">
                PREMIUM
              </p>
            </div>

            <div className="mb-6">
              <p className="text-xs font-serif italic text-[#a38f7e] mb-1">Membro Exclusivo</p>
              <p className="text-sm font-bold text-[#e8dcc4] tracking-widest">2026</p>
            </div>
          </div>

          {/* Efeito de Reflexo */}
          <motion.div 
            animate={{ x: ['-100%', '200%'] }}
            transition={{ duration: 6, repeat: Infinity, ease: "linear" }}
            className="absolute inset-0 z-20 pointer-events-none mix-blend-overlay opacity-20"
            style={{ 
              background: 'linear-gradient(110deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%)',
              width: '100%'
            }}
          />
        </div>

        {/* LOMBADA */}
        <div 
          className="absolute top-0 bottom-0 left-0 w-[40px] bg-[#1a120f] border-r border-[#3e2723]"
          style={{ transformOrigin: 'left', transform: 'translateZ(20px) rotateY(-90deg)' }}
        >
          <div className="flex flex-col items-center justify-center h-full text-[#cba365] opacity-40">
            <span 
              className="writing-vertical text-[9px] font-bold tracking-[0.4em] transform -rotate-180 uppercase"
              style={{ writingMode: 'vertical-rl' }}
            >
              UNIPET 2026
            </span>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default BookMockup;